import { z } from 'zod';
import { Id, IsoDateTime } from './common.js';

export const FaqEntry = z.object({
  faq_id: Id,
  merchant_id: Id,
  question: z.string().max(2000),
  answer: z.string().max(8000),
  tags: z.array(z.string()).default([]),
  priority: z.number().int().min(0).max(100).default(0),
  language_id: z.string(),
  embedding_state: z.enum(['pending', 'embedding', 'embedded', 'failed']).default('pending'),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type FaqEntry = z.infer<typeof FaqEntry>;

export const DocumentStatus = z.enum([
  'pending_processing',
  'processing',
  'processed',
  'failed',
]);

export const Document = z.object({
  document_id: Id,
  merchant_id: Id,
  filename: z.string(),
  r2_key: z.string(),
  file_size: z.number().int().nonnegative(),
  mime_type: z.string().default('application/pdf'),
  uploaded_at: IsoDateTime,
  status: DocumentStatus,
  error: z.string().nullable(),
  chunk_count: z.number().int().nonnegative().default(0),
});
export type Document = z.infer<typeof Document>;

export const DocumentChunk = z.object({
  chunk_id: Id,
  document_id: Id,
  merchant_id: Id,
  chunk_index: z.number().int().nonnegative(),
  text: z.string(),
  page_number: z.number().int().nullable(),
  section_heading: z.string().nullable(),
  token_count: z.number().int().nonnegative(),
});

export const KnowledgeHit = z.object({
  source: z.enum(['faq', 'document', 'business_info']),
  id: Id,
  title: z.string(),
  text: z.string(),
  score: z.number(),
  metadata: z.record(z.unknown()).default({}),
});
export type KnowledgeHit = z.infer<typeof KnowledgeHit>;

// Hard limits
export const KNOWLEDGE_LIMITS = {
  max_faq_entries: 200,
  max_total_document_bytes: 50 * 1024 * 1024,
  max_file_bytes: 10 * 1024 * 1024,
  default_chunk_tokens: 512,
  default_chunk_overlap_tokens: 50,
} as const;
